/*
 * A simple setTimeout with 0ms wrapper used to defer a callback.
 */
export const defer = (callback: () => void) => {
  setTimeout(callback, 0)
}
